import { ComponentProps, useEffect } from 'react';

import postMessageToParent from '../helpers/postMessageToParent';
import useIsOverlay from '../hooks/useIsOverlay';

import DefaultLayout from './DefaultLayout';
import OverlayLayout from './OverlayLayout';

type AutoOverlayOrDefaultLayoutProps = ComponentProps<typeof OverlayLayout>;

const AutoOverlayOrDefaultLayout = ({
    children,
    onIframeOverlayClose,
    ...props
}: AutoOverlayOrDefaultLayoutProps) => {
    const isOverlay = useIsOverlay();

    useEffect(() => {
        postMessageToParent({
            type: 'lb-navigate',
            path: window.location.href,
        });
        // eslint is complaining about the window.location.href dependency
        // but we need to run this effect every time the url changes
    }, [window.location.href]);

    if (isOverlay) {
        return (
            <OverlayLayout
                {...props}
                onIframeOverlayClose={onIframeOverlayClose}
            >
                {children}
            </OverlayLayout>
        );
    }

    return <DefaultLayout {...props}>{children}</DefaultLayout>;
};

export default AutoOverlayOrDefaultLayout;
